var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("search-bar", { on: { change: _vm.searchChange } }),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("intelligent-booking-table", {
              attrs: {
                "row-data": _vm.rowData,
                "tab-type": "tabTrash",
                "config-module": "310203"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "intelligent-tab-trash",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.queryPageHandler
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }